export const STAR_SPRITE = '/assets/letters-origami-stars-sprite.webp';
export const STAR_SPRITE_FALLBACK = '/assets/letters-origami-stars-sprite.png';

let sprite: HTMLImageElement | null = null;
let ready: Promise<HTMLImageElement> | null = null;

/** 在应用启动阶段预取并解码，避免路由懒加载后才出现星星。 */
export function preloadStarSprite(): Promise<HTMLImageElement> {
  if (typeof Image === 'undefined') return Promise.reject(new Error('Image is unavailable'));
  if (sprite?.complete && sprite.naturalWidth > 0) return Promise.resolve(sprite);
  if (!sprite) {
    sprite = new Image();
    sprite.decoding = 'async';
    sprite.src = STAR_SPRITE;
  }
  if (!ready) {
    ready = new Promise((resolve, reject) => {
      const current = sprite;
      if (!current) return reject(new Error('sprite unavailable'));
      current.onload = () => resolve(current);
      current.onerror = () => {
        if (current.src.endsWith(STAR_SPRITE)) {
          current.src = STAR_SPRITE_FALLBACK;
          current.onload = () => resolve(current);
          current.onerror = () => reject(new Error('star sprite failed to load'));
        } else {
          reject(new Error('star sprite failed to load'));
        }
      };
      if (current.complete && current.naturalWidth > 0) resolve(current);
    });
  }
  return ready;
}

export function getStarSprite(): HTMLImageElement | null {
  return sprite;
}
